export const TZ_FILTER = {
  SHOW_ALL: 'timezone-filter-all',
  SHOW_FULL_HOURS_ONLY: 'timezone-filter-full-hours-only',
  SHOW_GMT_ONLY: 'timezone-filter-gmt-only'
};
